import React, { useEffect, useState } from "react";
import "./AddModal.css";
import { Paginations, SpinnerLoading } from "../../../../components";
import { axiosGet } from "../../../../utils/apis/api";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import transportIcon from "../../../../assets/images/packages/svg/bus.svg";
import passengerIcon from "../../../../assets/images/packages/svg/fa-solid_users.svg";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { TextField } from "@mui/material";
import Cookies from "js-cookie";

const AddTransportModal = ({
  url,
  openTransport,
  setOpenTransportation,
  selectedDestination,
  selectedDates,
  handleAdd,
  setshowTransportationForm,
  setTransportationItems
}) => {
  const [value, setValue] = useState(null);

  const [loading, setLoading] = useState(false);
  const [transportations, setTransportations] = useState([]);
  const [capacity, setCapacity] = useState(null);
  const [selectedtransportations, setSelectedTransportations] = useState([]);
  // const [availabilityHours, setAvailabilityHours] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const resultsPerPage = 3;
  const { t } = useTranslation();
  const [clicked, setClicked] = React.useState(false);
  const Lang = Cookies.get("preferred_language") || "en";

  const fetchTrasportation = async (pageNumber = 1, newCapacity) => {
    try {
      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.transportation.transportation.transportation?start=${start}&limit=${resultsPerPage}`;
      if (newCapacity) {
        apiUrl += `&capacity=${newCapacity}`; 
      }
      if(selectedDestination){
        apiUrl+=`&destination=${selectedDestination.location}`
      }
      setLoading(true);
      const response = await axiosGet(apiUrl);

      const result = response.result;
      setCurrentPage(result.pagination.metadata.current_page);
      setTotalPages(result.pagination.metadata.total_pages);
      setTransportations(result.items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchTrasportation(pageNumber, capacity);
  };

  useEffect(() => {
    if (openTransport) {
      if (capacity) {
        fetchTrasportation(1, capacity);
      }
      else{
        fetchTrasportation();
      }
    }
  }, [openTransport, capacity]);

  const OnClick = async () => {
    if (!selectedtransportations || selectedtransportations.length === 0)
      return;

    const items = selectedtransportations.map((transport) => ({
      package_component_type: "Transportation",
      package_component_id: transport,
      destination_row_id: selectedDestination.primary_destination_row_id,
      date_from: selectedDates?.startDate
        ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
        : null,
      date_to: selectedDates?.endDate
        ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
        : null,
      from_destination: selectedDestination.location,
      to_destination: null,
    }));

    // const availability = selectedtransportations.reduce((acc, t) => {
    //   const transport = transportations.find((item) => item.name === t);
    //   if (transport) {
    //     console.log("transport",transport);
    //     acc[t] = transport.availability_hours_by_day;
    //   }
    //   return acc;
    // }, {});



    // handleAdd(items);
    if (items.length > 0){
      
      setTransportationItems(items);
      setOpenTransportation(false);
      setshowTransportationForm(true);

    }
    else {
      // TODO clear data and show validation
    }
    
  };

  const getModalHeightClass = () => {
    if (!loading && transportations.length <= 1) {
      return "small-height-modal";
    }
    return "large-height-modal";
  };

  if (!openTransport) return null;

  return (
    <Modal
      show={openTransport}
      onHide={() => {
        setSelectedTransportations([]);
        setTransportations([]);
        setCapacity(null);
        setValue(null);
        setCurrentPage(1);
        setTotalPages(1);
        setOpenTransportation(false);
      }}
      className={`add-modal add-transport-modal ${getModalHeightClass()} ${
        Lang === "ar" ? "rtl" : "ltr"
      }`}
      centered
    >
      <Modal.Body className="add-modal-body add-modal-body-transportation">
        <div className="add-logo">
          <img src={transportIcon} alt="transport icon" />
        </div>

        <div className="add-title">{t("AddTransportation")}</div>
        <div className="add-date">
          {dayjs(selectedDates.startDate).format("MMM D")} -{" "}
          {dayjs(selectedDates.endDate).format("MMM D")} {t("In")} {" "}
          {selectedDestination?.location_name}
        </div>
        <div className="add-hotel-desc">{t("chooseExtraService")}</div>

        <div className="capacity-dropdown-div">
          <div className="capacity-text">{t("Capacity")}</div>
          <TextField
            type="number"
            label={t("NumberOfPassengers")}
            placeholder={t("EnterCapacity")}
            className="capacity-dropdown"
            value={value}
            onChange={(event) => {
              const newValue = event.target.value;
              if (newValue && newValue >= 0) {
                setValue(newValue);
                setCapacity(newValue);
              } else {
                setValue(null);
                setCapacity(null);
              }
            }}
            inputProps={{ min: 0 }}
          />
        </div>

        <div className="transportation-scroll-container">
          <div className="transportation-div">
            {loading ? (
              <div className="loading-container">
                <SpinnerLoading />
              </div>
            ) : transportations.length > 0 ? (
              transportations.map((item, index) => (
                <div
                  className={`transport-div ${
                    selectedtransportations.includes(item.name)
                      ? "selected"
                      : ""
                  }`}
                  key={index}
                  onClick={() => {
                    setSelectedTransportations((prev) =>
                      prev.includes(item.name)
                        ? prev.filter((transport) => transport !== item.name)
                        : [...prev, item.name]
                    );
                  }}
                  // onClick={() => {
                  //   setSelectedTransportations((prev) =>
                  //     prev.includes(item.name)
                  //       ? prev.filter((transport) => transport !== item.name)
                  //       : [...prev, item.name]
                  //   );

                  //   setAvailabilityHours((prev) => ({
                  //     ...prev,
                  //     [item.name]: item.availability_hours_by_day
                  //   }));
                  // }}
                >
                  <div className="transport-name">{item.transportation_name}</div>
                  <div className="transport-desc">
                    {t("TransportationWithType")}
                    {" "}{t(item.type)} {t("And")} {item.availability_hours_by_day}{" "}
                    {t("HoursAvailabilityPerDay")}
                  </div>
                  <div className="passenger-num-div">
                    <img src={passengerIcon} alt="" />
                    <span className="num-Passengers">{item.capacity}</span>
                    <span> {t("Passengers")}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-transport-message">
                {t("NoTransportation")}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer-actions">
                  {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-5">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}

        <div
          className={`add-modal-submit transportaion-submit ${
            clicked ? "active clicked" : "active"
          }`}
          onClick={() => {
            setClicked(true);
            OnClick();
          }}
          disabled={selectedtransportations.length > 0 ? false : true}
        >
          {t("Continue")}
        </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddTransportModal;
